<template>
  <nav class="flex items-center justify-between flex-wrap bg-black p-6">
    <div class="flex items-center flex-shrink-0 text-white mr-6">
      <img src="../assets/images/experiaweb-black.png" width="81" height="81" />
      <!-- <span class="font-semibold text-xl tracking-tight">ExperiaWeb</span>  -->
    </div>
    <div class="block lg:hidden">
      <button
        @click="toggle"
        class="flex items-center px-3 py-2 border rounded text-white border-white hover:text-white hover:border-white navbar-burger"
      >
        <svg
          class="fill-current h-3 w-3"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>
    <div
      :class="open ? 'block' : 'hidden'"
      class="w-full block flex-grow lg:flex lg:items-center lg:w-auto"
    >
      <div class="text-sm lg:flex-grow">
        <router-link
          to="/"
          class="block mt-4 lg:inline-block lg:mt-0 text-grey hover:text-white mr-4"
          >Home</router-link
        >
        <router-link
          to="/services"
          class="block mt-4 lg:inline-block lg:mt-0 text-grey hover:text-white mr-4"
          >Services</router-link
        >
        <!-- <router-link
          to="/portfolio"
          class="block mt-4 lg:inline-block lg:mt-0 text-grey hover:text-white mr-4"
          >Portfolio</router-link
        >-->
        <router-link
          to="/pricing"
          class="block mt-4 lg:inline-block lg:mt-0 text-grey hover:text-white mr-4"
          >Pricing</router-link
        >
        <router-link
          to="/contact"
          class="block mt-4 lg:inline-block lg:mt-0 text-grey hover:text-white"
          >Contact Us</router-link
        >
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "navbar",
  data() {
    return {
      open: false
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
};
</script>
